const API_URL = 'https://api.tvfm.digitaltriumph.co.in/api/v1/';

export {
    API_URL
}